import urls from './api';
import { toJS } from 'mobx';

import store from '../store';
import {
    sui
} from '@sudy/sui-react'

const {
    ajax
} = sui

//获取学院报到情况
function getXueyuanStatics(type) {//1本专科生  2研究生
    ajax(urls.getxueyuantongji, {
        data: {
            category: type,
            randomKey:new Date().getTime()
        },
        success: function (response) {
            if (response.resultCode !== 0) {
                return
            }
            const res = response.result.data
            const arr = []
            res.forEach(function (item) {
                if (item.ZRS * 1 > 0) {
                    arr.push({
                        name: item.TITLE,
                        arrived: item.YQDRS,
                        shouldArrive: item.ZRS
                    })
                }

            })
            if (type === 1) {
                store.undergraduateAcademy = arr
            } else {
                store.postgraduateAcademy = arr
            }


        }

    })
}
//获取时间段统计
function getTimeStatics(type, queryDate) {//1本专科生  2研究生
    ajax(urls.gettimeTongji, {
        data: {
            category: type,
            queryDate
        },
        success: function (response) {
            if (response.resultCode !== 0) {
                return
            }
            const res = response.result.data
            const arr = []
            const data = res[0] || {}
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    const item = data[key];
                    arr.push({
                        name: key,
                        arrived: item,
                        shouldArrive: 0
                    })
                }
            }
            arr.sort(function (item1, item2) {
                return item1.name.split('-')[0] - item2.name.split('-')[0]
            })
            if (type === 1) {
                store.undergraduateTimeSlot = arr
            } else {
                store.postgraduateTimeSlot = arr
            }

        }

    })
}

//获取专业top10
function getTopStatics(type) {//1本专科生  2研究生
    ajax(urls.getzhuanyetop, {
        data: {
            category: type,
        },
        success: function (response) {
            if (response.resultCode !== 0) {
                return
            }
            const res = response.result.data
            const arr = []
            res.forEach(function (item) {
                arr.push({
                    name: item.TITLE,
                    arrived: item.YQDRS,
                    shouldArrive: item.ZRS
                })
            })
            if (arr.length > 10) {
                arr.length = 10
            }
            if (type === 1) {
                store.undergraduateTop = arr
            } else {
                store.postgraduateTop = arr
            }

        }

    })
}

//获取整体报到情况
function getallStatics() {
    ajax(urls.getall, {
        success: function (response) {
            if (response.resultCode !== 0) {
                return
            }
            const res = response.result.data
            const studentCategory = res.studentCategory[0] || {}
            const wholeStatistics = [{//整体统计
                name: "外地本专科生",
                arrived: studentCategory.BKSYQDRSWD,
                shouldArrive: studentCategory.BKSZRSWD
            }, {
                name: "本地本专科生",
                arrived: studentCategory.BKSYQDRSBD,
                shouldArrive: studentCategory.BKSZRSBD
            }, {
                name: "本专科生",
                arrived: studentCategory.BKSYQDRS,
                shouldArrive: studentCategory.BKSZRS
            }, {
                name: "研究生",
                arrived: studentCategory.YJSYQDRS,
                shouldArrive: studentCategory.YJSZRS
            }]


            const map = []
            let all = 0
            let sign = 0

            res.map.forEach(function (item) {
                map.push({
                    name: item.SF,
                    arrived: item.YQDRS,
                    shouldArrive: item.ZRS
                })
            })
            for (let i = 0; i < res.map.length; i++) {
                if(window.provinceEliminateItems && window.provinceEliminateItems.includes(res.map[i].SF)){
                    continue;
                }
              
                all += res.map[i].ZRS
                sign += res.map[i].YQDRS
            }
            store.allArrived = sign
            store.allShouldArrive = all
            store.province = map
            store.wholeStatistics = wholeStatistics
            store.international = {
                arrived:res.International && res.International[0] && res.International[0].LXSYBDRS,
                shouldArrive:res.International && res.International[0] && res.International[0].ZRS,
            }
        }

    })
}


//整体加载
function getAll() {
    const selectedDate = toJS(store.selectedDate)
    const date = selectedDate.format('YYYY-MM-DD')
    getXueyuanStatics(1)
    getXueyuanStatics(2)
    getTimeStatics(1, date)
    getTimeStatics(2, date)
    getTopStatics(1)
    getTopStatics(2)
    getallStatics()
}


export default {
    getAll,
    getTimeStatics,
}